export default "__VITE_ASSET__cf55c60a__"